import React, { useEffect, useRef, useState } from "react";
import PlaceOrderModal from "../../components/pos/place-order-modal";
import { pastOrderDetailsApi, checkoutApi } from "../../redux/apis/table-apis";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { printBillElectron } from "../../electron-utils/print-helper";

export default function PastOrderDetails() {
    const printRef = useRef();
    const navigate = useNavigate();

    const { id } = useParams();

    const [orderType, setOrderType] = useState("dining");
    const [paymentMode, setPaymentMode] = useState("cash");
    const [discountType, setDiscountType] = useState("none");
    const [discountValue, setDiscountValue] = useState(0);

    const [products, setProducts] = useState([]);
    const [orderObj, setOrderObj] = useState({
        name: "",
        phone: "",
        payment_method: "online",
        order_type: "parcel",
        total_before_tax: 0,
        cgst: 0,
        sgst: 0,
        total_after_tax: 0,
        discount: 0,
        parcel_charge: 0,
        total_after_tax_with_discount_parcel_charge: 0,
    });
    const [loading, setLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);
    const [data, setData] = useState({});

    const fetchOrderDetails = async () => {
        setLoading(true);
        try {
            const res = await pastOrderDetailsApi({ order_id: id });
            if (res.status === 200) {
                setData(res.data.data);

                setProducts([...res.data.data.order_products]);
                setOrderType(res.data.data.order.order_type);
                var orderDetails = res.data.data.order;
                if (orderDetails.discount > 0) {
                    setDiscountType("value");
                    setDiscountValue(orderDetails.discount);
                }
                setPaymentMode(orderDetails.payment_method);
                console.log("orderDetails", orderDetails);

                setOrderObj({
                    ...orderDetails,
                });
                // calculateOrderObj(res.data.data.order_products);
            } else {
                errorToast("Order Fetch Failed. Please retry.");
            }
        } catch (e) {
            console.log(e);
            errorToast("Order Fetch Failed. Please retry.");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchOrderDetails();
    }, []);

    const floatConverter = (value) => {
        var str = value.toFixed(2);

        var num = parseFloat(str);

        return num;
    };

    const calculateOrderObj = (productsArr) => {
        var orderObjWIP = {
            discount: 0,
            parcel_charge: 0,
            total_before_tax: 0,
            total_after_tax: 0,
            total_after_tax_with_discount_parcel_charge: 0,
            cgst: 0,
            sgst: 0,
        };
        console.log("productsArr", productsArr);

        for (let index = 0; index < productsArr.length; index++) {
            if (productsArr.qty == 0) {
                continue;
            }
            const product = productsArr[index];
            orderObjWIP.parcel_charge =
                product.parcel_charge_total + orderObjWIP.parcel_charge;

            orderObjWIP.total_before_tax =
                product.total_before_tax + orderObjWIP.total_before_tax;

            orderObjWIP.total_after_tax =
                product.total_after_tax + orderObjWIP.total_after_tax;

            orderObjWIP.cgst = product.cgst_total + orderObjWIP.cgst;

            orderObjWIP.sgst = product.sgst_total + orderObjWIP.sgst;
        }

        orderObjWIP.parcel_charge = floatConverter(
            orderObjWIP.parcel_charge ?? 0
        );
        orderObjWIP.total_before_tax = floatConverter(
            orderObjWIP.total_before_tax ?? 0
        );
        orderObjWIP.total_after_tax = floatConverter(
            orderObjWIP.total_after_tax ?? 0
        );
        orderObjWIP.sgst = floatConverter(orderObjWIP.sgst ?? 0);
        orderObjWIP.cgst = floatConverter(orderObjWIP.cgst ?? 0);

        if (discountType == "percentage") {
            var discountPer = discountValue ?? 0;
            if (discountPer > 0) {
                var discount =
                    ((orderObjWIP.parcel_charge +
                        orderObjWIP.total_before_tax) /
                        100) *
                    discountPer;
                discount = floatConverter(discount ?? 0);
                orderObjWIP.discount = discount;

                var cgstDiscount = (orderObjWIP.cgst / 100) * discountPer;
                cgstDiscount = floatConverter(cgstDiscount ?? 0);
                var sgstDiscount = (orderObjWIP.sgst / 100) * discountPer;
                sgstDiscount = floatConverter(sgstDiscount ?? 0);

                orderObjWIP.cgst = orderObjWIP.cgst - cgstDiscount;
                orderObjWIP.cgst = floatConverter(orderObjWIP.cgst ?? 0);

                orderObjWIP.sgst = orderObjWIP.sgst - sgstDiscount;
                orderObjWIP.sgst = floatConverter(orderObjWIP.sgst ?? 0);
            } else {
                orderObjWIP.discount = 0;
            }
        }

        if (discountType == "value") {
            if (discountValue > 0) {
                // var discount =(  (orderObjWIP.parcel_charge +orderObjWIP.total_before_tax )/100) * discountPer;
                var discount = discountValue;
                orderObjWIP.discount = discount;

                var discountPer =
                    (discountValue * 100) / orderObjWIP.total_before_tax;
                discountPer = floatConverter(discountPer ?? 0);
                var cgstDiscount = (orderObjWIP.cgst / 100) * discountPer;
                cgstDiscount = floatConverter(cgstDiscount ?? 0);
                var sgstDiscount = (orderObjWIP.sgst / 100) * discountPer;
                sgstDiscount = floatConverter(sgstDiscount ?? 0);

                orderObjWIP.cgst = orderObjWIP.cgst - cgstDiscount;
                orderObjWIP.cgst = floatConverter(orderObjWIP.cgst ?? 0);

                orderObjWIP.sgst = orderObjWIP.sgst - sgstDiscount;
                orderObjWIP.sgst = floatConverter(orderObjWIP.sgst ?? 0);
            } else {
                orderObjWIP.discount = 0;
            }
        }

        var totalAfterTPD =
            orderObjWIP.total_before_tax +
            orderObjWIP.parcel_charge -
            orderObjWIP.discount +
            orderObjWIP.cgst +
            orderObjWIP.sgst;

        orderObjWIP.total_after_tax_with_discount_parcel_charge =
            floatConverter(totalAfterTPD ?? 0);
        setOrderObj({
            ...orderObj,
            discount: orderObjWIP.discount,
            parcel_charge: orderObjWIP.parcel_charge,
            total_before_tax: orderObjWIP.total_before_tax,
            total_after_tax: orderObjWIP.total_after_tax,
            total_after_tax_with_discount_parcel_charge:
                orderObjWIP.total_after_tax_with_discount_parcel_charge,
            cgst: orderObjWIP.cgst,
            sgst: orderObjWIP.sgst,
        });
    };

    const productCalculation = (product) => {
        var total_before_tax = product.price * product.qty;
        total_before_tax = floatConverter(total_before_tax);
        var sgst_total = (total_before_tax / 100) * product.sgst;
        sgst_total = floatConverter(sgst_total ?? 0);
        var cgst_total = (total_before_tax / 100) * product.sgst;
        cgst_total = floatConverter(cgst_total ?? 0);
        var total_after_tax = total_before_tax + sgst_total + cgst_total;
        total_after_tax = floatConverter(total_after_tax ?? 0);
        var parcel_charge_total = 0;

        if (orderType != "dining") {
            parcel_charge_total = product.parcel_charge * product.qty;
            parcel_charge_total = floatConverter(parcel_charge_total);
        } else if (product.parcel == true) {
            parcel_charge_total = product.parcel_charge * product.qty;
            parcel_charge_total = floatConverter(parcel_charge_total);
        } else {
            parcel_charge_total = 0;
        }

        product.total_before_tax = total_before_tax;
        product.sgst_total = sgst_total;
        product.cgst_total = cgst_total;
        product.total_after_tax = total_after_tax;
        product.parcel_charge_total = parcel_charge_total;

        return product;
    };

    const addToCart = (item, itemIndex) => {
        var productsArr = [...products];

        for (let index = 0; index < productsArr.length; index++) {
            if (itemIndex == index) {
                var qty = productsArr[index].qty;
                productsArr[index].qty = qty + 1;
                productsArr[index] = productCalculation(productsArr[index]);
            }
        }
        setProducts([...productsArr]);
        calculateOrderObj(productsArr);
    };

    const printBill = ()=>{
        printBillElectron(data.order, products);
    }
    useEffect(() => {
        console.log("discountValue", discountValue);
        var productsArr = updateAllProductPricing();
        calculateOrderObj(productsArr);
    }, [discountValue, orderType]);

    const updateAllProductPricing = () => {
        var productsArr = [...products];
        for (let index = 0; index < productsArr.length; index++) {
            productsArr[index] = productCalculation(productsArr[index]);
        }
        setProducts([...productsArr]);
        return productsArr;
    };

    const removeFromCart = (item, itemIndex) => {
        var productsArr = [...products];

        for (let index = 0; index < productsArr.length; index++) {
            if (itemIndex == index) {
                var qty = productsArr[index].qty;
                productsArr[index].qty = qty > 1 ? qty - 1 : 0;
                productsArr[index] = productCalculation(productsArr[index]);
            }
        }
        setProducts([...productsArr]);
        calculateOrderObj(productsArr);
    };

    const handleConfirmOrder = async () => {
        setBtnLoading(true);
        try {
            var params = {
                ...orderObj,
                order_type: orderType,
                payment_method: paymentMode,
                order_id: id,
                products: [...products],
            };
            var res = await checkoutApi(params);

            console.log("checkoutApi res", res);

            if (res.status == 200) {
                console.log(res.data.data);
                // setPrintData(res.data.data);
                //TODO integrate print bill;
                // await Alert.alert('Order Placed Success fully', 'Print Bill');
                printRef.current.showDialog(
                    res.data.data.order,
                    res.data.data.order_products
                );
                // navigation.dispatch(StackActions.pop(2));
                successToast(res.data.message);
            } else {
                errorToast(res.data.message);
            }
        } catch (error) {
            console.log("error", error);
            errorToast("Order Checkout failed , Please Go Back and retry");
        }
        setBtnLoading(false);
    };

    if (loading) return <div className="p-6 text-center">Loading...</div>;

    return (
        <div className="h-[75vh] bg-white flex flex-col">
            <PlaceOrderModal ref={printRef} />

            {/* Header */}
            <div className="flex items-center border-b px-4 py-3 bg-gray-50">
                <button onClick={() => navigate(-1)} className="mr-3">
                    ←
                </button>
                <h1 className="text-lg font-semibold">
                    {" "}
                    {data.order.invoice_number}: Past Order Details
                </h1>

                <button
                    onClick={printBill}
                    disabled={btnLoading}
                    className="w-60 ml-20 py-2 px-4 bg-red-600 text-white rounded font-semibold hover:bg-red-700 disabled:opacity-50"
                >
                    Print Bill
                </button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-6 pb-10">
                {/* Order Type */}
                <div>
                    <h2 className="text-lg font-medium mb-2">Order Type</h2>
                    <div className="flex space-x-6">
                        {[
                            { label: "Parcel", value: "parcel" },
                            { label: "Have Here", value: "dining" },
                        ].map((opt) => (
                            <label
                                key={opt.value}
                                className="flex items-center space-x-2 cursor-pointer"
                            >
                                <input
                                    type="radio"
                                    checked={orderType === opt.value}
                                    onChange={() => setOrderType(opt.value)}
                                    className="accent-green-600"
                                />
                                <span>{opt.label}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* User Info */}
                <div className="space-y-4">
                    <div>
                        <label className="block font-medium">
                            Phone Number
                        </label>
                        <input
                            type="text"
                            placeholder="Phone Number"
                            className="w-full border rounded px-3 py-2"
                            value={orderObj.phone}
                            onChange={(e) =>
                                setOrderObj({
                                    ...orderObj,
                                    phone: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div>
                        <label className="block font-medium">Name</label>
                        <input
                            type="text"
                            placeholder="Name"
                            value={orderObj.name}
                            className="w-full border rounded px-3 py-2"
                            onChange={(e) =>
                                setOrderObj({
                                    ...orderObj,
                                    name: e.target.value,
                                })
                            }
                        />
                    </div>
                </div>

                {/* Discount */}
                <div>
                    <h2 className="text-lg font-medium mb-2">Discount</h2>
                    <div className="flex space-x-6">
                        {[
                            { label: "None", value: "none" },
                            { label: "Value", value: "value" },
                            { label: "Percentage", value: "percentage" },
                        ].map((opt) => (
                            <label
                                key={opt.value}
                                className="flex items-center space-x-2 cursor-pointer"
                            >
                                <input
                                    type="radio"
                                    checked={discountType === opt.value}
                                    onChange={() => setDiscountType(opt.value)}
                                    className="accent-green-600"
                                />
                                <span>{opt.label}</span>
                            </label>
                        ))}
                    </div>
                    {discountType !== "none" && (
                        <input
                            type="number"
                            placeholder="Value"
                            className="w-full mt-3 border rounded px-3 py-2"
                            value={discountValue}
                            onChange={(e) =>
                                setDiscountValue(Number(e.target.value))
                            }
                        />
                    )}
                </div>

                {/* Payment */}
                <div>
                    <h2 className="text-lg font-medium mb-2">Payment Using</h2>
                    <div className="flex space-x-6">
                        {[
                            { label: "Online", value: "online" },
                            { label: "Cash", value: "cash" },
                        ].map((opt) => (
                            <label
                                key={opt.value}
                                className="flex items-center space-x-2 cursor-pointer"
                            >
                                <input
                                    type="radio"
                                    checked={paymentMode === opt.value}
                                    onChange={() => setPaymentMode(opt.value)}
                                    className="accent-green-600"
                                />
                                <span>{opt.label}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Products */}
                <div>
                    <h2 className="text-lg font-medium mb-2">Products</h2>
                    <div className="divide-y">
                        {products.map((item, idx) => (
                            <div
                                key={item.id}
                                className="flex items-center py-3"
                            >
                                {item.photo && (
                                    <img
                                        src={item.photo}
                                        alt={item.name}
                                        className="w-14 h-14 rounded mr-4 object-cover"
                                    />
                                )}

                                <div className="flex-1">
                                    <p className="font-medium">{item.name}</p>
                                    <p className="text-sm text-gray-500">
                                        ₹{item.price}
                                    </p>
                                    {item.parcel && (
                                        <p className="text-xs text-gray-400">
                                            Parcel
                                        </p>
                                    )}
                                </div>
                                <div className="flex items-center bg-gray-100 rounded">
                                    <button
                                        className="px-3 py-1 bg-red-500 text-white rounded-l"
                                        onClick={() =>
                                            removeFromCart(item, idx)
                                        }
                                    >
                                        -
                                    </button>
                                    <span className="px-4 font-semibold">
                                        {item.qty}
                                    </span>
                                    <button
                                        className="px-3 py-1 bg-green-500 text-white rounded-r"
                                        onClick={() => addToCart(item, idx)}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Billing */}
                <div className="space-y-2 border-t pt-4">
                    <h2 className="text-lg font-medium mb-2">
                        Billing Details
                    </h2>
                    <div className="flex justify-between">
                        <span>Total Price Value:</span>
                        <span>₹ {orderObj.total_before_tax}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Parcel Charges:</span>
                        <span>₹ {orderObj.parcel_charge}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Discount:</span>
                        <span>- ₹ {orderObj.discount}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>CGST:</span>
                        <span>₹ {orderObj.cgst}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>SGST:</span>
                        <span>₹ {orderObj.sgst}</span>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className=" fixed bottom-0 left-0 right-0 border-t bg-gray-50 p-4 space-y-4">
                <div className="flex justify-between text-lg font-semibold">
                    <span>Total Value Of Order:</span>
                    <span>
                        ₹ {orderObj.total_after_tax_with_discount_parcel_charge}
                    </span>
                </div>
                <button
                    onClick={handleConfirmOrder}
                    disabled={btnLoading}
                    className="w-full py-3 bg-red-600 text-white rounded font-semibold hover:bg-red-700 disabled:opacity-50"
                >
                    {btnLoading ? "Processing..." : "Update ORDER"}
                </button>
            </div>
        </div>
    );
}
